import { keyName } from '@tunasong/music-lib'
import type { Entity } from '@tunasong/schemas'
import { isSong } from '@tunasong/schemas'
import { tempoLabel } from './part/part-header-line.js'

/** "Key Dm · ♩=118": what a performer needs to know about the next song before it starts. */
export const songMeta = (entity: Entity | undefined): string | undefined => {
  if (!isSong(entity)) {
    return undefined
  }
  const key = entity.scale ? `Key ${keyName(entity.scale)}` : undefined
  const tempo = entity.rhythm?.tempo ? tempoLabel(entity.rhythm.tempo, entity.rhythm.meter) : undefined
  const meta = [key, tempo].filter(Boolean).join(' · ')
  return meta === '' ? undefined : meta
}
